
// => Styling
import styles from './ChoicesContainer.module.css';

// => Components
import Choice from './Choice';


// ============
// Component
// ============
const ChoicesContainer = ({ question = null }) => {


    // RENDER
    // ---------
    return(
        <div className={styles.container}>
            
            {/* Map choice data to choice buttons */}
            {(question !== null && question.choices.length > 0) &&
                question.choices.map((c, index) =>
                    <Choice label={c.choiceText}
                            index={index}
                            key={"_choice-"+index}
                            onChoice={question.choices[index].onChoice} />
            )}

        </div>
    )
}


export default ChoicesContainer